import React from 'react';
import { CheckCircle } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_flats-clean-service/artifacts/2b1a8yim_Screenshot_20260123_012606_Drive.jpg";

const QuoteAccepted = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-5 py-5 flex items-center justify-center">
          <img src={LOGO_URL} alt="Just Cleaned" className="h-8 w-auto object-contain" />
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-5 py-10">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 sm:p-10 text-center">
          <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-green-600" />
          </div>
          
          <h1 className="text-2xl font-semibold text-gray-900 mb-4">
            Thank you — your quote has been accepted.
          </h1>
          
          <p className="text-gray-600 leading-relaxed">
            We'll be in touch shortly to arrange your start date and onboarding.
          </p>
          
          <div className="mt-8 pt-6 border-t border-gray-100">
            <p className="text-sm text-gray-500">
              If you have any questions in the meantime, please email us at{' '}
              <a href="mailto:justcleanedltd@gmail.com" className="text-[#1a1f4e] hover:underline">
                justcleanedltd@gmail.com
              </a>
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center">
        <p className="text-gray-400 text-sm">
          Over 4 years' experience maintaining managed residential blocks across London.
        </p>
      </footer>
    </div>
  );
};

export default QuoteAccepted;
